export const getPopupStackLength = (state) => {
  return state.popupStack.length;
};
